// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { patchDeviceConfiguration } from '../../services/DeviceService';
import { DeviceConfiguration, DeviceConfigurationPatch } from '../../types/Devices';

type Result = UseMutationResult<DeviceConfiguration, Error, DeviceConfigurationPatch>;

function usePatchDeviceConfiguration(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(patchDeviceConfiguration, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['device-configuration'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePatchDeviceConfiguration;
